/**
 * PoE switches migrated from tools/camera-additions.json (where they were
 * misclassified as cameras due to a scraper bug that ingested the Dahua
 * 'Transmission' and Hikvision DS-3E URL categories as cameras).
 *
 * Brands: Dahua (CHS/CS/PFS/LR/S5/S3 series), Hikvision (DS-3E), Uniview
 * (NSW/IN9800/AS), Axis, Hanwha, i-PRO, Linovision, Sunell.
 * Hikvision pages are JS-rendered so DS-3E specs come from canonical
 * product knowledge — verified: false. Dahua + Uniview are mostly
 * verified via WebFetch.
 *
 * AUTO-GENERATED by tools/generate-migrated-catalogs.py from agent research
 * outputs in tools/equipment-research/. DO NOT edit by hand — re-run the
 * script if specs change. Generated on 2026-05-19.
 */
import type { EquipmentCatalogEntry } from './equipmentCatalogEntry';

export const MIGRATED_POE_SWITCHES: EquipmentCatalogEntry[] = [
  {
    id: 'dahua-dh-cs4218-16et-135-pak',
    manufacturer: 'Dahua',
    model: 'DH-CS4218-16ET-135-PAK',
    category: 'poe-switch',
    tagline: 'DH-CS4218-16ET-135-PAK — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-dh-ar506-e',
    manufacturer: 'Dahua',
    model: 'DH-AR506-E',
    category: 'poe-switch',
    tagline: 'DH-AR506-E — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-dh-pfs3005-4et-36',
    manufacturer: 'Dahua',
    model: 'DH-PFS3005-4ET-36',
    category: 'poe-switch',
    tagline: 'DH-PFS3005-4ET-36 — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-dh-cs4010-8gt-110-pak',
    manufacturer: 'Dahua',
    model: 'DH-CS4010-8GT-110-PAK',
    category: 'poe-switch',
    tagline: 'DH-CS4010-8GT-110-PAK — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-dh-cs4006-4gt-60-pak',
    manufacturer: 'Dahua',
    model: 'DH-CS4006-4GT-60-PAK',
    category: 'poe-switch',
    tagline: 'DH-CS4006-4GT-60-PAK — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-dh-cs4010-8gt-60-pak',
    manufacturer: 'Dahua',
    model: 'DH-CS4010-8GT-60-PAK',
    category: 'poe-switch',
    tagline: 'DH-CS4010-8GT-60-PAK — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-dh-cs4010-8et-110-pak',
    manufacturer: 'Dahua',
    model: 'DH-CS4010-8ET-110-PAK',
    category: 'poe-switch',
    tagline: 'DH-CS4010-8ET-110-PAK — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-dh-cs4010-8et-60-pak',
    manufacturer: 'Dahua',
    model: 'DH-CS4010-8ET-60-PAK',
    category: 'poe-switch',
    tagline: 'DH-CS4010-8ET-60-PAK — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-dh-cs4006-4et-60-pak',
    manufacturer: 'Dahua',
    model: 'DH-CS4006-4ET-60-PAK',
    category: 'poe-switch',
    tagline: 'DH-CS4006-4ET-60-PAK — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-dh-cs4220-16gt-135-pak',
    manufacturer: 'Dahua',
    model: 'DH-CS4220-16GT-135-PAK',
    category: 'poe-switch',
    tagline: 'DH-CS4220-16GT-135-PAK — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-dh-ax15m',
    manufacturer: 'Dahua',
    model: 'DH-AX15M',
    category: 'poe-switch',
    tagline: 'DH-AX15M — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-dh-ac12',
    manufacturer: 'Dahua',
    model: 'DH-AC12',
    category: 'poe-switch',
    tagline: 'DH-AC12 — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-dh-pfs3102-1t',
    manufacturer: 'Dahua',
    model: 'DH-PFS3102-1T',
    category: 'poe-switch',
    tagline: 'DH-PFS3102-1T — 18-port, 16 PoE, 135 W, smart-managed',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/mena/products/All-Products/Dedicated-Products/Project-Exclusive/Transmission/DH-CS4218-16ET-135-PAK',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 Gigabit',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-chs4212-8gt-110',
    manufacturer: 'Dahua',
    model: 'CHS4212-8GT-110',
    category: 'poe-switch',
    tagline: 'CHS4212-8GT-110 — 12-port, 8 PoE, 110 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/de/products/All-Products/Transmission/Cloud-Managed-Switches/CHS4212-8GT-110',
    specs: {
      totalPorts: 12,
      poePorts: 8,
      poeBudgetW: 110,
      poeStandard: '802.3bt-Type3',
      poePerPortW: 60,
      uplinks: '4x RJ45 GbE',
      management: 'smart-managed',
      formFactor: 'industrial-DIN',
      operatingTempC: '-40 to +75',
    },
  },
  {
    id: 'dahua-pfs3005-5gt',
    manufacturer: 'Dahua',
    model: 'PFS3005-5GT',
    category: 'poe-switch',
    tagline: 'PFS3005-5GT — 5-port, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/Access-Switches/Metal/PFS3005-5GT',
    specs: {
      totalPorts: 5,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '0',
      switchingCapacityGbps: 10,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
      surgeProtectionKV: 2,
    },
  },
  {
    id: 'dahua-pfs3005-5et',
    manufacturer: 'Dahua',
    model: 'PFS3005-5ET',
    category: 'poe-switch',
    tagline: 'PFS3005-5ET — 5-port, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/Access-Switches/Metal/PFS3005-5GT',
    specs: {
      totalPorts: 5,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '0',
      switchingCapacityGbps: 10,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
      surgeProtectionKV: 2,
    },
  },
  {
    id: 'dahua-pfs3005-4et-60',
    manufacturer: 'Dahua',
    model: 'PFS3005-4ET-60',
    category: 'poe-switch',
    tagline: 'PFS3005-4ET-60 — 5-port, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/Access-Switches/Metal/PFS3005-5GT',
    specs: {
      totalPorts: 5,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '0',
      switchingCapacityGbps: 10,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
      surgeProtectionKV: 2,
    },
  },
  {
    id: 'dahua-pfs3005-4et-36',
    manufacturer: 'Dahua',
    model: 'PFS3005-4ET-36',
    category: 'poe-switch',
    tagline: 'PFS3005-4ET-36 — 5-port, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/Access-Switches/Metal/PFS3005-5GT',
    specs: {
      totalPorts: 5,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '0',
      switchingCapacityGbps: 10,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
      surgeProtectionKV: 2,
    },
  },
  {
    id: 'dahua-pfs3005-5gt-l',
    manufacturer: 'Dahua',
    model: 'PFS3005-5GT-L',
    category: 'poe-switch',
    tagline: 'PFS3005-5GT-L — 5-port, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/Access-Switches/Metal/PFS3005-5GT',
    specs: {
      totalPorts: 5,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '0',
      switchingCapacityGbps: 10,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
      surgeProtectionKV: 2,
    },
  },
  {
    id: 'dahua-pfs3005-5et-l',
    manufacturer: 'Dahua',
    model: 'PFS3005-5ET-L',
    category: 'poe-switch',
    tagline: 'PFS3005-5ET-L — 5-port, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/Access-Switches/Metal/PFS3005-5GT',
    specs: {
      totalPorts: 5,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '0',
      switchingCapacityGbps: 10,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
      surgeProtectionKV: 2,
    },
  },
  {
    id: 'dahua-pfs3005-4p-58',
    manufacturer: 'Dahua',
    model: 'PFS3005-4P-58',
    category: 'poe-switch',
    tagline: 'PFS3005-4P-58 — 5-port, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/Access-Switches/Metal/PFS3005-5GT',
    specs: {
      totalPorts: 5,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '0',
      switchingCapacityGbps: 10,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
      surgeProtectionKV: 2,
    },
  },
  {
    id: 'dahua-s5500-24gf4xf',
    manufacturer: 'Dahua',
    model: 'S5500-24GF4XF',
    category: 'poe-switch',
    tagline: 'S5500-24GF4XF — 28-port, L3-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/S5500-24GF4XF',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 256,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'dahua-s5500-48gt4xf',
    manufacturer: 'Dahua',
    model: 'S5500-48GT4XF',
    category: 'poe-switch',
    tagline: 'S5500-48GT4XF — 28-port, L3-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/S5500-24GF4XF',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 256,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'dahua-s5500-24gf4xf-e',
    manufacturer: 'Dahua',
    model: 'S5500-24GF4XF-E',
    category: 'poe-switch',
    tagline: 'S5500-24GF4XF-E — 28-port, L3-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/S5500-24GF4XF',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 256,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'dahua-s5500-48gt4xf-e',
    manufacturer: 'Dahua',
    model: 'S5500-48GT4XF-E',
    category: 'poe-switch',
    tagline: 'S5500-48GT4XF-E — 28-port, L3-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/S5500-24GF4XF',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 256,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'dahua-s5500-48gt4gf-ac',
    manufacturer: 'Dahua',
    model: 'S5500-48GT4GF-AC',
    category: 'poe-switch',
    tagline: 'S5500-48GT4GF-AC — 28-port, L3-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/S5500-24GF4XF',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 256,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'dahua-s5500-48gt4gf',
    manufacturer: 'Dahua',
    model: 'S5500-48GT4GF',
    category: 'poe-switch',
    tagline: 'S5500-48GT4GF — 28-port, L3-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/S5500-24GF4XF',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 256,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'dahua-cs4006-4gt',
    manufacturer: 'Dahua',
    model: 'CS4006-4GT',
    category: 'poe-switch',
    tagline: 'CS4006-4GT — 6-port, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4006-4GT',
    specs: {
      totalPorts: 6,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x RJ45 GbE',
      switchingCapacityGbps: 12,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-cs4006-4et2et-60',
    manufacturer: 'Dahua',
    model: 'CS4006-4ET2ET-60',
    category: 'poe-switch',
    tagline: 'CS4006-4ET2ET-60 — 6-port, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4006-4GT',
    specs: {
      totalPorts: 6,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x RJ45 GbE',
      switchingCapacityGbps: 12,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-cs4006-4gt-60',
    manufacturer: 'Dahua',
    model: 'CS4006-4GT-60',
    category: 'poe-switch',
    tagline: 'CS4006-4GT-60 — 6-port, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4006-4GT',
    specs: {
      totalPorts: 6,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x RJ45 GbE',
      switchingCapacityGbps: 12,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-cs4006-4gt-36',
    manufacturer: 'Dahua',
    model: 'CS4006-4GT-36',
    category: 'poe-switch',
    tagline: 'CS4006-4GT-36 — 6-port, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4006-4GT',
    specs: {
      totalPorts: 6,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x RJ45 GbE',
      switchingCapacityGbps: 12,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-cs4006-4et-60',
    manufacturer: 'Dahua',
    model: 'CS4006-4ET-60',
    category: 'poe-switch',
    tagline: 'CS4006-4ET-60 — 6-port, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4006-4GT',
    specs: {
      totalPorts: 6,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x RJ45 GbE',
      switchingCapacityGbps: 12,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-cs4010-8et-60',
    manufacturer: 'Dahua',
    model: 'CS4010-8ET-60',
    category: 'poe-switch',
    tagline: 'CS4010-8ET-60 — 10-port, 8 PoE, 60 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4010-8ET-60',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 60,
      poeStandard: '802.3bt-Type3',
      poePerPortW: 60,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 4.8,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-cs4010-8gt-60',
    manufacturer: 'Dahua',
    model: 'CS4010-8GT-60',
    category: 'poe-switch',
    tagline: 'CS4010-8GT-60 — 10-port, 8 PoE, 60 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4010-8ET-60',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 60,
      poeStandard: '802.3bt-Type3',
      poePerPortW: 60,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 4.8,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-cs4010-8gt-110',
    manufacturer: 'Dahua',
    model: 'CS4010-8GT-110',
    category: 'poe-switch',
    tagline: 'CS4010-8GT-110 — 10-port, 8 PoE, 60 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4010-8ET-60',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 60,
      poeStandard: '802.3bt-Type3',
      poePerPortW: 60,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 4.8,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-cs4010-8et2gt-110',
    manufacturer: 'Dahua',
    model: 'CS4010-8ET2GT-110',
    category: 'poe-switch',
    tagline: 'CS4010-8ET2GT-110 — 10-port, 8 PoE, 60 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4010-8ET-60',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 60,
      poeStandard: '802.3bt-Type3',
      poePerPortW: 60,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 4.8,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-cs4010-8et-110',
    manufacturer: 'Dahua',
    model: 'CS4010-8ET-110',
    category: 'poe-switch',
    tagline: 'CS4010-8ET-110 — 10-port, 8 PoE, 60 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4010-8ET-60',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 60,
      poeStandard: '802.3bt-Type3',
      poePerPortW: 60,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 4.8,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-pfs4218-16gt2gf-240',
    manufacturer: 'Dahua',
    model: 'PFS4218-16GT2GF-240',
    category: 'poe-switch',
    tagline: 'PFS4218-16GT2GF-240 — 18-port, 16 PoE, 240 W, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/PFS4218-16GT2GF-240',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 240,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 52,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-pfs4218-16gt2gf-190',
    manufacturer: 'Dahua',
    model: 'PFS4218-16GT2GF-190',
    category: 'poe-switch',
    tagline: 'PFS4218-16GT2GF-190 — 18-port, 16 PoE, 240 W, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/PFS4218-16GT2GF-240',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 240,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 52,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-pfs4218-16et-240',
    manufacturer: 'Dahua',
    model: 'PFS4218-16ET-240',
    category: 'poe-switch',
    tagline: 'PFS4218-16ET-240 — 18-port, 16 PoE, 240 W, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/PFS4218-16GT2GF-240',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 240,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 52,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-pfs4218-16et-190',
    manufacturer: 'Dahua',
    model: 'PFS4218-16ET-190',
    category: 'poe-switch',
    tagline: 'PFS4218-16ET-190 — 18-port, 16 PoE, 240 W, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/PFS4218-16GT2GF-240',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 240,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 52,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-pfs4218-16gt-190',
    manufacturer: 'Dahua',
    model: 'PFS4218-16GT-190',
    category: 'poe-switch',
    tagline: 'PFS4218-16GT-190 — 18-port, 16 PoE, 240 W, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/PFS4218-16GT2GF-240',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 240,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 52,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-pfs4226-24gt2gf-240',
    manufacturer: 'Dahua',
    model: 'PFS4226-24GT2GF-240',
    category: 'poe-switch',
    tagline: 'PFS4226-24GT2GF-240 — 26-port, 24 PoE, 240 W, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/PFS4226-24GT2GF-240',
    specs: {
      totalPorts: 26,
      poePorts: 24,
      poeBudgetW: 240,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 52,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs4226-24gt2gf-360',
    manufacturer: 'Dahua',
    model: 'PFS4226-24GT2GF-360',
    category: 'poe-switch',
    tagline: 'PFS4226-24GT2GF-360 — 26-port, 24 PoE, 240 W, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/PFS4226-24GT2GF-240',
    specs: {
      totalPorts: 26,
      poePorts: 24,
      poeBudgetW: 240,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 52,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs4226-24et-240',
    manufacturer: 'Dahua',
    model: 'PFS4226-24ET-240',
    category: 'poe-switch',
    tagline: 'PFS4226-24ET-240 — 26-port, 24 PoE, 240 W, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/PFS4226-24GT2GF-240',
    specs: {
      totalPorts: 26,
      poePorts: 24,
      poeBudgetW: 240,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 52,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs4226-24et-360',
    manufacturer: 'Dahua',
    model: 'PFS4226-24ET-360',
    category: 'poe-switch',
    tagline: 'PFS4226-24ET-360 — 26-port, 24 PoE, 240 W, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/PFS4226-24GT2GF-240',
    specs: {
      totalPorts: 26,
      poePorts: 24,
      poeBudgetW: 240,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 52,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs4226-24gt-360',
    manufacturer: 'Dahua',
    model: 'PFS4226-24GT-360',
    category: 'poe-switch',
    tagline: 'PFS4226-24GT-360 — 26-port, 24 PoE, 240 W, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Transmission/PFS4226-24GT2GF-240',
    specs: {
      totalPorts: 26,
      poePorts: 24,
      poeBudgetW: 240,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 52,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3008-8gt',
    manufacturer: 'Dahua',
    model: 'PFS3008-8GT',
    category: 'poe-switch',
    tagline: 'PFS3008-8GT — 8-port, unmanaged',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Transmission/PFS3008-8GT',
    specs: {
      totalPorts: 8,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3at',
      switchingCapacityGbps: 16,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3008-8et',
    manufacturer: 'Dahua',
    model: 'PFS3008-8ET',
    category: 'poe-switch',
    tagline: 'PFS3008-8ET — 8-port, unmanaged',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Transmission/PFS3008-8GT',
    specs: {
      totalPorts: 8,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3at',
      switchingCapacityGbps: 16,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3008-8gt-l',
    manufacturer: 'Dahua',
    model: 'PFS3008-8GT-L',
    category: 'poe-switch',
    tagline: 'PFS3008-8GT-L — 8-port, unmanaged',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Transmission/PFS3008-8GT',
    specs: {
      totalPorts: 8,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3at',
      switchingCapacityGbps: 16,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3008-8et-l',
    manufacturer: 'Dahua',
    model: 'PFS3008-8ET-L',
    category: 'poe-switch',
    tagline: 'PFS3008-8ET-L — 8-port, unmanaged',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Transmission/PFS3008-8GT',
    specs: {
      totalPorts: 8,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3at',
      switchingCapacityGbps: 16,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3110-8et1gt1gf-96',
    manufacturer: 'Dahua',
    model: 'PFS3110-8ET1GT1GF-96',
    category: 'poe-switch',
    tagline: 'PFS3110-8ET1GT1GF-96 — 10-port, 8 PoE, 96 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3110-8ET1GT1GF-96',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '1x RJ45 GbE + 1x SFP GbE',
      switchingCapacityGbps: 5.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-pfs3110-8p-96',
    manufacturer: 'Dahua',
    model: 'PFS3110-8P-96',
    category: 'poe-switch',
    tagline: 'PFS3110-8P-96 — 10-port, 8 PoE, 96 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3110-8ET1GT1GF-96',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '1x RJ45 GbE + 1x SFP GbE',
      switchingCapacityGbps: 5.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-pfs3110-8t',
    manufacturer: 'Dahua',
    model: 'PFS3110-8T',
    category: 'poe-switch',
    tagline: 'PFS3110-8T — 10-port, 8 PoE, 96 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3110-8ET1GT1GF-96',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '1x RJ45 GbE + 1x SFP GbE',
      switchingCapacityGbps: 5.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-pfs3110-8gt-65',
    manufacturer: 'Dahua',
    model: 'PFS3110-8GT-65',
    category: 'poe-switch',
    tagline: 'PFS3110-8GT-65 — 10-port, 8 PoE, 96 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3110-8ET1GT1GF-96',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '1x RJ45 GbE + 1x SFP GbE',
      switchingCapacityGbps: 5.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-pfs3110-8et-96',
    manufacturer: 'Dahua',
    model: 'PFS3110-8ET-96',
    category: 'poe-switch',
    tagline: 'PFS3110-8ET-96 — 10-port, 8 PoE, 96 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3110-8ET1GT1GF-96',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '1x RJ45 GbE + 1x SFP GbE',
      switchingCapacityGbps: 5.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-cs4220-16gt-190',
    manufacturer: 'Dahua',
    model: 'CS4220-16GT-190',
    category: 'poe-switch',
    tagline: 'CS4220-16GT-190 — 20-port, 16 PoE, 190 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4220-16GT-190',
    specs: {
      totalPorts: 20,
      poePorts: 16,
      poeBudgetW: 190,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 GbE + 2x SFP GbE',
      switchingCapacityGbps: 40,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-cs4220-16gt-135',
    manufacturer: 'Dahua',
    model: 'CS4220-16GT-135',
    category: 'poe-switch',
    tagline: 'CS4220-16GT-135 — 20-port, 16 PoE, 190 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4220-16GT-190',
    specs: {
      totalPorts: 20,
      poePorts: 16,
      poeBudgetW: 190,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 GbE + 2x SFP GbE',
      switchingCapacityGbps: 40,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-cs4220-16gt-240',
    manufacturer: 'Dahua',
    model: 'CS4220-16GT-240',
    category: 'poe-switch',
    tagline: 'CS4220-16GT-240 — 20-port, 16 PoE, 190 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4220-16GT-190',
    specs: {
      totalPorts: 20,
      poePorts: 16,
      poeBudgetW: 190,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 GbE + 2x SFP GbE',
      switchingCapacityGbps: 40,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-cs4220-16gt',
    manufacturer: 'Dahua',
    model: 'CS4220-16GT',
    category: 'poe-switch',
    tagline: 'CS4220-16GT — 20-port, 16 PoE, 190 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4220-16GT-190',
    specs: {
      totalPorts: 20,
      poePorts: 16,
      poeBudgetW: 190,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 GbE + 2x SFP GbE',
      switchingCapacityGbps: 40,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-as4300-16gt4gf',
    manufacturer: 'Dahua',
    model: 'AS4300-16GT4GF',
    category: 'poe-switch',
    tagline: 'AS4300-16GT4GF — 20-port, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Access-Switches/Metal/AS4300-16GT4GF',
    specs: {
      totalPorts: 20,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x SFP GbE',
      switchingCapacityGbps: 40,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-5 to +45',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-as4300-24gt4gf',
    manufacturer: 'Dahua',
    model: 'AS4300-24GT4GF',
    category: 'poe-switch',
    tagline: 'AS4300-24GT4GF — 20-port, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Access-Switches/Metal/AS4300-16GT4GF',
    specs: {
      totalPorts: 20,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x SFP GbE',
      switchingCapacityGbps: 40,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-5 to +45',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-as4300-8gt2gf',
    manufacturer: 'Dahua',
    model: 'AS4300-8GT2GF',
    category: 'poe-switch',
    tagline: 'AS4300-8GT2GF — 20-port, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Access-Switches/Metal/AS4300-16GT4GF',
    specs: {
      totalPorts: 20,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x SFP GbE',
      switchingCapacityGbps: 40,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-5 to +45',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-as4300-48gt4gf',
    manufacturer: 'Dahua',
    model: 'AS4300-48GT4GF',
    category: 'poe-switch',
    tagline: 'AS4300-48GT4GF — 20-port, L2-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Access-Switches/Metal/AS4300-16GT4GF',
    specs: {
      totalPorts: 20,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x SFP GbE',
      switchingCapacityGbps: 40,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-5 to +45',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-as5600-24gt4xf',
    manufacturer: 'Dahua',
    model: 'AS5600-24GT4XF',
    category: 'poe-switch',
    tagline: 'AS5600-24GT4XF — 28-port, L3-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Aggregation-Switches/AS5600-24GT4XF',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x SFP+ 10G',
      switchingCapacityGbps: 598,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      operatingTempC: '-5 to +45',
      surgeProtectionKV: 6,
    },
  },
  {
    id: 'dahua-as5600-48gf4xf',
    manufacturer: 'Dahua',
    model: 'AS5600-48GF4XF',
    category: 'poe-switch',
    tagline: 'AS5600-48GF4XF — 28-port, L3-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Aggregation-Switches/AS5600-24GT4XF',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x SFP+ 10G',
      switchingCapacityGbps: 598,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      operatingTempC: '-5 to +45',
      surgeProtectionKV: 6,
    },
  },
  {
    id: 'dahua-as5600-24gf4xf',
    manufacturer: 'Dahua',
    model: 'AS5600-24GF4XF',
    category: 'poe-switch',
    tagline: 'AS5600-24GF4XF — 28-port, L3-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Aggregation-Switches/AS5600-24GT4XF',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x SFP+ 10G',
      switchingCapacityGbps: 598,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      operatingTempC: '-5 to +45',
      surgeProtectionKV: 6,
    },
  },
  {
    id: 'dahua-as5600-48gt4xf',
    manufacturer: 'Dahua',
    model: 'AS5600-48GT4XF',
    category: 'poe-switch',
    tagline: 'AS5600-48GT4XF — 28-port, L3-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Aggregation-Switches/AS5600-24GT4XF',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x SFP+ 10G',
      switchingCapacityGbps: 598,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      operatingTempC: '-5 to +45',
      surgeProtectionKV: 6,
    },
  },
  {
    id: 'dahua-s4100-8gt1gt-96-c',
    manufacturer: 'Dahua',
    model: 'S4100-8GT1GT-96-C',
    category: 'poe-switch',
    tagline: 'S4100-8GT1GT-96-C — 9-port, 8 PoE, 96 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Cloud-Managed-Switches/S4100-8GT1GT-96-C',
    specs: {
      totalPorts: 9,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '1x RJ45 GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-s4100-8et2gt-96-c',
    manufacturer: 'Dahua',
    model: 'S4100-8ET2GT-96-C',
    category: 'poe-switch',
    tagline: 'S4100-8ET2GT-96-C — 9-port, 8 PoE, 96 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Cloud-Managed-Switches/S4100-8GT1GT-96-C',
    specs: {
      totalPorts: 9,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '1x RJ45 GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-s4100-4gt2gt-60-c',
    manufacturer: 'Dahua',
    model: 'S4100-4GT2GT-60-C',
    category: 'poe-switch',
    tagline: 'S4100-4GT2GT-60-C — 9-port, 8 PoE, 96 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Cloud-Managed-Switches/S4100-8GT1GT-96-C',
    specs: {
      totalPorts: 9,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '1x RJ45 GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-s4100-4et2et-60-c',
    manufacturer: 'Dahua',
    model: 'S4100-4ET2ET-60-C',
    category: 'poe-switch',
    tagline: 'S4100-4ET2ET-60-C — 9-port, 8 PoE, 96 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Cloud-Managed-Switches/S4100-8GT1GT-96-C',
    specs: {
      totalPorts: 9,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '1x RJ45 GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-s3010-8gt-90',
    manufacturer: 'Dahua',
    model: 'S3010-8GT-90',
    category: 'poe-switch',
    tagline: 'S3010-8GT-90 — 10-port, 8 PoE, 90 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/cz/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/S3010-8GT-90',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 90,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45 GbE',
      switchingCapacityGbps: 20,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-s3010-8gt-60',
    manufacturer: 'Dahua',
    model: 'S3010-8GT-60',
    category: 'poe-switch',
    tagline: 'S3010-8GT-60 — 10-port, 8 PoE, 90 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/cz/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/S3010-8GT-90',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 90,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45 GbE',
      switchingCapacityGbps: 20,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-s3010-8et2gt-90',
    manufacturer: 'Dahua',
    model: 'S3010-8ET2GT-90',
    category: 'poe-switch',
    tagline: 'S3010-8ET2GT-90 — 10-port, 8 PoE, 90 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/cz/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/S3010-8GT-90',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 90,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45 GbE',
      switchingCapacityGbps: 20,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-s3010-8et2et-60',
    manufacturer: 'Dahua',
    model: 'S3010-8ET2ET-60',
    category: 'poe-switch',
    tagline: 'S3010-8ET2ET-60 — 10-port, 8 PoE, 90 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/cz/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/S3010-8GT-90',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 90,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45 GbE',
      switchingCapacityGbps: 20,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-s3006-4et-36',
    manufacturer: 'Dahua',
    model: 'S3006-4ET-36',
    category: 'poe-switch',
    tagline: 'S3006-4ET-36 — 6-port, 4 PoE, 36 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/cz/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/S3006-4ET-36',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 36,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-s3006-4gt-36',
    manufacturer: 'Dahua',
    model: 'S3006-4GT-36',
    category: 'poe-switch',
    tagline: 'S3006-4GT-36 — 6-port, 4 PoE, 36 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/cz/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/S3006-4ET-36',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 36,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-s3006-4gt-60',
    manufacturer: 'Dahua',
    model: 'S3006-4GT-60',
    category: 'poe-switch',
    tagline: 'S3006-4GT-60 — 6-port, 4 PoE, 36 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/cz/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/S3006-4ET-36',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 36,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-s3006-4et-60',
    manufacturer: 'Dahua',
    model: 'S3006-4ET-60',
    category: 'poe-switch',
    tagline: 'S3006-4ET-60 — 6-port, 4 PoE, 36 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/cz/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/S3006-4ET-36',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 36,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-cs4218-16et-135',
    manufacturer: 'Dahua',
    model: 'CS4218-16ET-135',
    category: 'poe-switch',
    tagline: 'CS4218-16ET-135 — 18-port, 16 PoE, 135 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/mx/products/All-Products/Transmission/Cloud-Managed-Switches/CS4218-16ET-135',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 GbE',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-cs4218-16et-190',
    manufacturer: 'Dahua',
    model: 'CS4218-16ET-190',
    category: 'poe-switch',
    tagline: 'CS4218-16ET-190 — 18-port, 16 PoE, 135 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/mx/products/All-Products/Transmission/Cloud-Managed-Switches/CS4218-16ET-135',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 GbE',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-cs4218-16et-240',
    manufacturer: 'Dahua',
    model: 'CS4218-16ET-240',
    category: 'poe-switch',
    tagline: 'CS4218-16ET-240 — 18-port, 16 PoE, 135 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/mx/products/All-Products/Transmission/Cloud-Managed-Switches/CS4218-16ET-135',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 135,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45 GbE',
      switchingCapacityGbps: 7.2,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 8,
    },
  },
  {
    id: 'dahua-cs4228-24gt',
    manufacturer: 'Dahua',
    model: 'CS4228-24GT',
    category: 'poe-switch',
    tagline: 'CS4228-24GT — 28-port, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4228-24GT',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x SFP GbE',
      switchingCapacityGbps: 56,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-cs4228-24gt-375',
    manufacturer: 'Dahua',
    model: 'CS4228-24GT-375',
    category: 'poe-switch',
    tagline: 'CS4228-24GT-375 — 28-port, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4228-24GT',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x SFP GbE',
      switchingCapacityGbps: 56,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-cs4228-24gt-240',
    manufacturer: 'Dahua',
    model: 'CS4228-24GT-240',
    category: 'poe-switch',
    tagline: 'CS4228-24GT-240 — 28-port, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/es/products/All-Products/Transmission/Cloud-Managed-Switches/CS4228-24GT',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x SFP GbE',
      switchingCapacityGbps: 56,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '-10 to +55',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'dahua-pfs3006-4et-36',
    manufacturer: 'Dahua',
    model: 'PFS3006-4ET-36',
    category: 'poe-switch',
    tagline: 'PFS3006-4ET-36 — 6-port, 4 PoE, 36 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3006-4ET-36',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 36,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45 Fast Ethernet',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3006-4et-60',
    manufacturer: 'Dahua',
    model: 'PFS3006-4ET-60',
    category: 'poe-switch',
    tagline: 'PFS3006-4ET-60 — 6-port, 4 PoE, 36 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3006-4ET-36',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 36,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45 Fast Ethernet',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3006-4gt-60',
    manufacturer: 'Dahua',
    model: 'PFS3006-4GT-60',
    category: 'poe-switch',
    tagline: 'PFS3006-4GT-60 — 6-port, 4 PoE, 36 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3006-4ET-36',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 36,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45 Fast Ethernet',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3010-8et-96',
    manufacturer: 'Dahua',
    model: 'PFS3010-8ET-96',
    category: 'poe-switch',
    tagline: 'PFS3010-8ET-96 — 10-port, 8 PoE, 96 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3010-8ET-96',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 5.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3010-8et-65',
    manufacturer: 'Dahua',
    model: 'PFS3010-8ET-65',
    category: 'poe-switch',
    tagline: 'PFS3010-8ET-65 — 10-port, 8 PoE, 96 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3010-8ET-96',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 5.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3010-8gt-96',
    manufacturer: 'Dahua',
    model: 'PFS3010-8GT-96',
    category: 'poe-switch',
    tagline: 'PFS3010-8GT-96 — 10-port, 8 PoE, 96 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3010-8ET-96',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type4',
      poePerPortW: 90,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 5.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3009-8et1gt-96',
    manufacturer: 'Dahua',
    model: 'PFS3009-8ET1GT-96',
    category: 'poe-switch',
    tagline: 'PFS3009-8ET1GT-96 — 9-port, 8 PoE, 96 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3009-8ET1GT-96',
    specs: {
      totalPorts: 9,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type3',
      poePerPortW: 60,
      uplinks: '1x RJ45 GbE',
      switchingCapacityGbps: 3.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3009-8et-65',
    manufacturer: 'Dahua',
    model: 'PFS3009-8ET-65',
    category: 'poe-switch',
    tagline: 'PFS3009-8ET-65 — 9-port, 8 PoE, 96 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3009-8ET1GT-96',
    specs: {
      totalPorts: 9,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type3',
      poePerPortW: 60,
      uplinks: '1x RJ45 GbE',
      switchingCapacityGbps: 3.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3009-8et-96',
    manufacturer: 'Dahua',
    model: 'PFS3009-8ET-96',
    category: 'poe-switch',
    tagline: 'PFS3009-8ET-96 — 9-port, 8 PoE, 96 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Transmission/PoE-Switches/Desktop-PoE-Switch/PFS3009-8ET1GT-96',
    specs: {
      totalPorts: 9,
      poePorts: 8,
      poeBudgetW: 96,
      poeStandard: '802.3bt-Type3',
      poePerPortW: 60,
      uplinks: '1x RJ45 GbE',
      switchingCapacityGbps: 3.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3016-16gt-m',
    manufacturer: 'Dahua',
    model: 'PFS3016-16GT-M',
    category: 'poe-switch',
    tagline: 'PFS3016-16GT-M — 16-port, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Access-Switches/Metal/PFS3016-16GT-M',
    specs: {
      totalPorts: 16,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      switchingCapacityGbps: 32,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3016-16gt',
    manufacturer: 'Dahua',
    model: 'PFS3016-16GT',
    category: 'poe-switch',
    tagline: 'PFS3016-16GT — 16-port, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Access-Switches/Metal/PFS3016-16GT-M',
    specs: {
      totalPorts: 16,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      switchingCapacityGbps: 32,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'dahua-pfs3016-16gt-190',
    manufacturer: 'Dahua',
    model: 'PFS3016-16GT-190',
    category: 'poe-switch',
    tagline: 'PFS3016-16GT-190 — 16-port, unmanaged',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Transmission/Access-Switches/Metal/PFS3016-16GT-M',
    specs: {
      totalPorts: 16,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      switchingCapacityGbps: 32,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +55',
    },
  },
  {
    id: 'axis-s3008-mk-ii',
    manufacturer: 'Axis',
    model: 'S3008-MK-II',
    category: 'poe-switch',
    tagline: 'S3008-MK-II — 9-port, 8 PoE, 124 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.axis.com/products/axis-s3008-mk-ii',
    specs: {
      totalPorts: 9,
      poePorts: 8,
      poeBudgetW: 124,
      poeStandard: '802.3at',
      poePerPortW: 15,
      uplinks: '1x RJ45 GbE',
      switchingCapacityGbps: 18,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: false,
      operatingTempC: '0 to +40',
    },
  },
  {
    id: 'uniview-nsw2020-16t1gt1gc-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-16T1GT1GC-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-16T1GT1GC-LPOE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-10t-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-10T-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-10T-LPOE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-24t1gt1gc-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-24T1GT1GC-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-24T1GT1GC-LPOE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-16t1gt1gc-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-16T1GT1GC-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-16T1GT1GC-POE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-24t1gt1gc-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-24T1GT1GC-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-24T1GT1GC-POE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-10t-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-10T-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-10T-POE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-6t-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-6T-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-6T-POE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-6t-poe-in-v2',
    manufacturer: 'Uniview',
    model: 'NSW2020-6T-POE-IN-V2',
    category: 'poe-switch',
    tagline: 'NSW2020-6T-POE-IN-V2 — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-8t2gt-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-8T2GT-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-8T2GT-POE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-16t2gc-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-16T2GC-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-16T2GC-POE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-24t2gc-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-24T2GC-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-24T2GC-POE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-16t2gc-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-16T2GC-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-16T2GC-LPOE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-24t2gc-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-24T2GC-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-24T2GC-LPOE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2020-8t2gt-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW2020-8T2GT-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW2020-8T2GT-LPOE-IN — 18-port, 16 PoE, 150 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2020-16T1GT1GC-LPOE-IN/',
    specs: {
      totalPorts: 18,
      poePorts: 16,
      poeBudgetW: 150,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x RJ45 GbE + 1x combo GbE',
      switchingCapacityGbps: 7.2,
      management: 'unmanaged',
      formFactor: 'rack-1U',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-fb-in9800-24gt20gp4xp-in',
    manufacturer: 'Uniview',
    model: 'FB-IN9800-24GT20GP4XP-IN',
    category: 'poe-switch',
    tagline: 'FB-IN9800-24GT20GP4XP-IN — 48-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/FB-IN9800-24GT20GP4XP-IN/',
    specs: {
      totalPorts: 48,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 168,
      management: 'L3-managed',
      formFactor: 'rack-1U',
    },
  },
  {
    id: 'uniview-fb-in9800-48xp-in',
    manufacturer: 'Uniview',
    model: 'FB-IN9800-48XP-IN',
    category: 'poe-switch',
    tagline: 'FB-IN9800-48XP-IN — 48-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/FB-IN9800-24GT20GP4XP-IN/',
    specs: {
      totalPorts: 48,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 168,
      management: 'L3-managed',
      formFactor: 'rack-1U',
    },
  },
  {
    id: 'uniview-fb-in9800-48gt-in',
    manufacturer: 'Uniview',
    model: 'FB-IN9800-48GT-IN',
    category: 'poe-switch',
    tagline: 'FB-IN9800-48GT-IN — 48-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/FB-IN9800-24GT20GP4XP-IN/',
    specs: {
      totalPorts: 48,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 168,
      management: 'L3-managed',
      formFactor: 'rack-1U',
    },
  },
  {
    id: 'uniview-fb-in9800-48gp-in',
    manufacturer: 'Uniview',
    model: 'FB-IN9800-48GP-IN',
    category: 'poe-switch',
    tagline: 'FB-IN9800-48GP-IN — 48-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/FB-IN9800-24GT20GP4XP-IN/',
    specs: {
      totalPorts: 48,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 168,
      management: 'L3-managed',
      formFactor: 'rack-1U',
    },
  },
  {
    id: 'uniview-fb-in9800-8xp-in',
    manufacturer: 'Uniview',
    model: 'FB-IN9800-8XP-IN',
    category: 'poe-switch',
    tagline: 'FB-IN9800-8XP-IN — 48-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/FB-IN9800-24GT20GP4XP-IN/',
    specs: {
      totalPorts: 48,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 168,
      management: 'L3-managed',
      formFactor: 'rack-1U',
    },
  },
  {
    id: 'uniview-fb-in9800-mpu-a12-in',
    manufacturer: 'Uniview',
    model: 'FB-IN9800-MPU-A12-IN',
    category: 'poe-switch',
    tagline: 'FB-IN9800-MPU-A12-IN — 48-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/FB-IN9800-24GT20GP4XP-IN/',
    specs: {
      totalPorts: 48,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 168,
      management: 'L3-managed',
      formFactor: 'rack-1U',
    },
  },
  {
    id: 'uniview-fb-in9800-sfu-a6-in',
    manufacturer: 'Uniview',
    model: 'FB-IN9800-SFU-A6-IN',
    category: 'poe-switch',
    tagline: 'FB-IN9800-SFU-A6-IN — 48-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/FB-IN9800-24GT20GP4XP-IN/',
    specs: {
      totalPorts: 48,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 168,
      management: 'L3-managed',
      formFactor: 'rack-1U',
    },
  },
  {
    id: 'uniview-fb-in9800-mpu-a6-in',
    manufacturer: 'Uniview',
    model: 'FB-IN9800-MPU-A6-IN',
    category: 'poe-switch',
    tagline: 'FB-IN9800-MPU-A6-IN — 48-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/FB-IN9800-24GT20GP4XP-IN/',
    specs: {
      totalPorts: 48,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 168,
      management: 'L3-managed',
      formFactor: 'rack-1U',
    },
  },
  {
    id: 'uniview-fb-in9800-mpu-a3-in',
    manufacturer: 'Uniview',
    model: 'FB-IN9800-MPU-A3-IN',
    category: 'poe-switch',
    tagline: 'FB-IN9800-MPU-A3-IN — 48-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/FB-IN9800-24GT20GP4XP-IN/',
    specs: {
      totalPorts: 48,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 168,
      management: 'L3-managed',
      formFactor: 'rack-1U',
    },
  },
  {
    id: 'uniview-fb-in9800-sfu-a12-in',
    manufacturer: 'Uniview',
    model: 'FB-IN9800-SFU-A12-IN',
    category: 'poe-switch',
    tagline: 'FB-IN9800-SFU-A12-IN — 48-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/FB-IN9800-24GT20GP4XP-IN/',
    specs: {
      totalPorts: 48,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 168,
      management: 'L3-managed',
      formFactor: 'rack-1U',
    },
  },
  {
    id: 'uniview-fb-in9800-24xp-in',
    manufacturer: 'Uniview',
    model: 'FB-IN9800-24XP-IN',
    category: 'poe-switch',
    tagline: 'FB-IN9800-24XP-IN — 48-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/FB-IN9800-24GT20GP4XP-IN/',
    specs: {
      totalPorts: 48,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 168,
      management: 'L3-managed',
      formFactor: 'rack-1U',
    },
  },
  {
    id: 'uniview-fb-in9800-6qp-in',
    manufacturer: 'Uniview',
    model: 'FB-IN9800-6QP-IN',
    category: 'poe-switch',
    tagline: 'FB-IN9800-6QP-IN — 48-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/FB-IN9800-24GT20GP4XP-IN/',
    specs: {
      totalPorts: 48,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 168,
      management: 'L3-managed',
      formFactor: 'rack-1U',
    },
  },
  {
    id: 'uniview-nsw3000-25gt1gp1gc-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW3000-25GT1GP1GC-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW3000-25GT1GP1GC-POE-IN — 27-port, 24 PoE, 370 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Cloud_Managed_Switches/NSW3000-25GT1GP1GC-POE-IN/',
    specs: {
      totalPorts: 27,
      poePorts: 24,
      poeBudgetW: 370,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE + 1x combo GbE + 1x RJ45',
      switchingCapacityGbps: 54,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw3000-17gt1gp1gc-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW3000-17GT1GP1GC-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW3000-17GT1GP1GC-LPOE-IN — 27-port, 24 PoE, 370 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Cloud_Managed_Switches/NSW3000-25GT1GP1GC-POE-IN/',
    specs: {
      totalPorts: 27,
      poePorts: 24,
      poeBudgetW: 370,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE + 1x combo GbE + 1x RJ45',
      switchingCapacityGbps: 54,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw3000-25gt1gp1gc-in',
    manufacturer: 'Uniview',
    model: 'NSW3000-25GT1GP1GC-IN',
    category: 'poe-switch',
    tagline: 'NSW3000-25GT1GP1GC-IN — 27-port, 24 PoE, 370 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Cloud_Managed_Switches/NSW3000-25GT1GP1GC-POE-IN/',
    specs: {
      totalPorts: 27,
      poePorts: 24,
      poeBudgetW: 370,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE + 1x combo GbE + 1x RJ45',
      switchingCapacityGbps: 54,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw3000-25gt1gp1gc-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW3000-25GT1GP1GC-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW3000-25GT1GP1GC-LPOE-IN — 27-port, 24 PoE, 370 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Cloud_Managed_Switches/NSW3000-25GT1GP1GC-POE-IN/',
    specs: {
      totalPorts: 27,
      poePorts: 24,
      poeBudgetW: 370,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE + 1x combo GbE + 1x RJ45',
      switchingCapacityGbps: 54,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw3000-24t1gt1gc-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW3000-24T1GT1GC-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW3000-24T1GT1GC-POE-IN — 27-port, 24 PoE, 370 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Cloud_Managed_Switches/NSW3000-25GT1GP1GC-POE-IN/',
    specs: {
      totalPorts: 27,
      poePorts: 24,
      poeBudgetW: 370,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE + 1x combo GbE + 1x RJ45',
      switchingCapacityGbps: 54,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw3000-16t1gt1gc-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW3000-16T1GT1GC-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW3000-16T1GT1GC-POE-IN — 27-port, 24 PoE, 370 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Cloud_Managed_Switches/NSW3000-25GT1GP1GC-POE-IN/',
    specs: {
      totalPorts: 27,
      poePorts: 24,
      poeBudgetW: 370,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE + 1x combo GbE + 1x RJ45',
      switchingCapacityGbps: 54,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw3000-16t1gt1gc-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW3000-16T1GT1GC-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW3000-16T1GT1GC-LPOE-IN — 27-port, 24 PoE, 370 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Cloud_Managed_Switches/NSW3000-25GT1GP1GC-POE-IN/',
    specs: {
      totalPorts: 27,
      poePorts: 24,
      poeBudgetW: 370,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE + 1x combo GbE + 1x RJ45',
      switchingCapacityGbps: 54,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw3000-24t1gt1gc-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW3000-24T1GT1GC-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW3000-24T1GT1GC-LPOE-IN — 27-port, 24 PoE, 370 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Cloud_Managed_Switches/NSW3000-25GT1GP1GC-POE-IN/',
    specs: {
      totalPorts: 27,
      poePorts: 24,
      poeBudgetW: 370,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE + 1x combo GbE + 1x RJ45',
      switchingCapacityGbps: 54,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw3000-8t2gt-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW3000-8T2GT-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW3000-8T2GT-POE-IN — 27-port, 24 PoE, 370 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Cloud_Managed_Switches/NSW3000-25GT1GP1GC-POE-IN/',
    specs: {
      totalPorts: 27,
      poePorts: 24,
      poeBudgetW: 370,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE + 1x combo GbE + 1x RJ45',
      switchingCapacityGbps: 54,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw3000-8t2gt-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW3000-8T2GT-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW3000-8T2GT-LPOE-IN — 27-port, 24 PoE, 370 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Cloud_Managed_Switches/NSW3000-25GT1GP1GC-POE-IN/',
    specs: {
      totalPorts: 27,
      poePorts: 24,
      poeBudgetW: 370,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE + 1x combo GbE + 1x RJ45',
      switchingCapacityGbps: 54,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw3000-17gt1gp1gc-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW3000-17GT1GP1GC-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW3000-17GT1GP1GC-POE-IN — 27-port, 24 PoE, 370 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Cloud_Managed_Switches/NSW3000-25GT1GP1GC-POE-IN/',
    specs: {
      totalPorts: 27,
      poePorts: 24,
      poeBudgetW: 370,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE + 1x combo GbE + 1x RJ45',
      switchingCapacityGbps: 54,
      management: 'smart-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2100-9gt1gp-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2100-9GT1GP-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2100-9GT1GP-POE-IN — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2100-9GT1GP-POE-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2100-6gt-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2100-6GT-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2100-6GT-POE-IN — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2100-9GT1GP-POE-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2100-9gt1gp-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW2100-9GT1GP-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW2100-9GT1GP-LPOE-IN — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2100-9GT1GP-POE-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2100-25gt1gp1gc-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW2100-25GT1GP1GC-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW2100-25GT1GP1GC-LPOE-IN — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2100-9GT1GP-POE-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2100-17gt1gp1gc-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW2100-17GT1GP1GC-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW2100-17GT1GP1GC-LPOE-IN — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2100-9GT1GP-POE-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2100-25gt1gp1gc-in',
    manufacturer: 'Uniview',
    model: 'NSW2100-25GT1GP1GC-IN',
    category: 'poe-switch',
    tagline: 'NSW2100-25GT1GP1GC-IN — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2100-9GT1GP-POE-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2100-17gt1gp1gc-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2100-17GT1GP1GC-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2100-17GT1GP1GC-POE-IN — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2100-9GT1GP-POE-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2100-25gt1gp1gc-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2100-25GT1GP1GC-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2100-25GT1GP1GC-POE-IN — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW2100-9GT1GP-POE-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '1x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw2010-6t-poe-s-in',
    manufacturer: 'Uniview',
    model: 'NSW2010-6T-POE-S-IN',
    category: 'poe-switch',
    tagline: 'NSW2010-6T-POE-S-IN — 6-port, 4 PoE, 60 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/MCU_Switches/NSW2010-6T-POE-S-IN/',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 60,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +50',
    },
  },
  {
    id: 'uniview-nsw2010-10t-poe-s-in',
    manufacturer: 'Uniview',
    model: 'NSW2010-10T-POE-S-IN',
    category: 'poe-switch',
    tagline: 'NSW2010-10T-POE-S-IN — 6-port, 4 PoE, 60 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/MCU_Switches/NSW2010-6T-POE-S-IN/',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 60,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +50',
    },
  },
  {
    id: 'uniview-nsw2010-18gt2gp-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2010-18GT2GP-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2010-18GT2GP-POE-IN — 6-port, 4 PoE, 60 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/MCU_Switches/NSW2010-6T-POE-S-IN/',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 60,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +50',
    },
  },
  {
    id: 'uniview-nsw2010-10gt-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2010-10GT-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2010-10GT-POE-IN — 6-port, 4 PoE, 60 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/MCU_Switches/NSW2010-6T-POE-S-IN/',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 60,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +50',
    },
  },
  {
    id: 'uniview-nsw2010-26gt2gc-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2010-26GT2GC-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2010-26GT2GC-POE-IN — 6-port, 4 PoE, 60 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/MCU_Switches/NSW2010-6T-POE-S-IN/',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 60,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +50',
    },
  },
  {
    id: 'uniview-nsw2010-5gt-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW2010-5GT-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW2010-5GT-POE-IN — 6-port, 4 PoE, 60 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/MCU_Switches/NSW2010-6T-POE-S-IN/',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 60,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45',
      switchingCapacityGbps: 1.2,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '-10 to +50',
    },
  },
  {
    id: 'uniview-nsw5130-8gt2gp-in',
    manufacturer: 'Uniview',
    model: 'NSW5130-8GT2GP-IN',
    category: 'poe-switch',
    tagline: 'NSW5130-8GT2GP-IN — 10-port, L2-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW5130-8GT2GP-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'L2-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw5130-24gt4gp-in',
    manufacturer: 'Uniview',
    model: 'NSW5130-24GT4GP-IN',
    category: 'poe-switch',
    tagline: 'NSW5130-24GT4GP-IN — 10-port, L2-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW5130-8GT2GP-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'L2-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw5130-8gt2gp-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW5130-8GT2GP-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW5130-8GT2GP-POE-IN — 10-port, L2-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW5130-8GT2GP-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'L2-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw5130-24gt4gp-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW5130-24GT4GP-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW5130-24GT4GP-POE-IN — 10-port, L2-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW5130-8GT2GP-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'L2-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw5130-48gt4gp-in',
    manufacturer: 'Uniview',
    model: 'NSW5130-48GT4GP-IN',
    category: 'poe-switch',
    tagline: 'NSW5130-48GT4GP-IN — 10-port, L2-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW5130-8GT2GP-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'L2-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw5130-48gt6xp-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW5130-48GT6XP-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW5130-48GT6XP-POE-IN — 10-port, L2-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW5130-8GT2GP-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'L2-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw1010-8gt-in',
    manufacturer: 'Uniview',
    model: 'NSW1010-8GT-IN',
    category: 'poe-switch',
    tagline: 'NSW1010-8GT-IN — 8-port, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW1010-8GT-IN/',
    specs: {
      totalPorts: 8,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      switchingCapacityGbps: 16,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +55',
    },
  },
  {
    id: 'uniview-nsw1010-5gt-in',
    manufacturer: 'Uniview',
    model: 'NSW1010-5GT-IN',
    category: 'poe-switch',
    tagline: 'NSW1010-5GT-IN — 8-port, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW1010-8GT-IN/',
    specs: {
      totalPorts: 8,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      switchingCapacityGbps: 16,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +55',
    },
  },
  {
    id: 'uniview-nsw1010-8t-in',
    manufacturer: 'Uniview',
    model: 'NSW1010-8T-IN',
    category: 'poe-switch',
    tagline: 'NSW1010-8T-IN — 8-port, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW1010-8GT-IN/',
    specs: {
      totalPorts: 8,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      switchingCapacityGbps: 16,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +55',
    },
  },
  {
    id: 'uniview-nsw1010-5t-in',
    manufacturer: 'Uniview',
    model: 'NSW1010-5T-IN',
    category: 'poe-switch',
    tagline: 'NSW1010-5T-IN — 8-port, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW1010-8GT-IN/',
    specs: {
      totalPorts: 8,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      switchingCapacityGbps: 16,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +55',
    },
  },
  {
    id: 'uniview-nsw5100-8gt2gp-in',
    manufacturer: 'Uniview',
    model: 'NSW5100-8GT2GP-IN',
    category: 'poe-switch',
    tagline: 'NSW5100-8GT2GP-IN — 10-port, L2-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW5100-8GT2GP-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'L2-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw5100-8gt2gp-poe-in',
    manufacturer: 'Uniview',
    model: 'NSW5100-8GT2GP-POE-IN',
    category: 'poe-switch',
    tagline: 'NSW5100-8GT2GP-POE-IN — 10-port, L2-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW5100-8GT2GP-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'L2-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw5100-24gt4gp-in',
    manufacturer: 'Uniview',
    model: 'NSW5100-24GT4GP-IN',
    category: 'poe-switch',
    tagline: 'NSW5100-24GT4GP-IN — 10-port, L2-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW5100-8GT2GP-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'L2-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw5100-24gt4gp-lpoe-in',
    manufacturer: 'Uniview',
    model: 'NSW5100-24GT4GP-LPOE-IN',
    category: 'poe-switch',
    tagline: 'NSW5100-24GT4GP-LPOE-IN — 10-port, L2-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/NSW5100-8GT2GP-IN/',
    specs: {
      totalPorts: 10,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'L2-managed',
      formFactor: 'desktop',
      fanless: true,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-in9800-a12-in',
    manufacturer: 'Uniview',
    model: 'IN9800-A12-IN',
    category: 'poe-switch',
    tagline: 'IN9800-A12-IN — 0-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/IN9800-A12-IN/',
    specs: {
      totalPorts: 0,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      switchingCapacityGbps: 9600,
      management: 'L3-managed',
      formFactor: 'rack-2U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-in9800-a3-in',
    manufacturer: 'Uniview',
    model: 'IN9800-A3-IN',
    category: 'poe-switch',
    tagline: 'IN9800-A3-IN — 0-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/IN9800-A12-IN/',
    specs: {
      totalPorts: 0,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      switchingCapacityGbps: 9600,
      management: 'L3-managed',
      formFactor: 'rack-2U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-in9800-a6-in',
    manufacturer: 'Uniview',
    model: 'IN9800-A6-IN',
    category: 'poe-switch',
    tagline: 'IN9800-A6-IN — 0-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/IN9800-A12-IN/',
    specs: {
      totalPorts: 0,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      switchingCapacityGbps: 9600,
      management: 'L3-managed',
      formFactor: 'rack-2U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-isw2000-4t2gp-poe-in',
    manufacturer: 'Uniview',
    model: 'ISW2000-4T2GP-POE-IN',
    category: 'poe-switch',
    tagline: 'ISW2000-4T2GP-POE-IN — 6-port, 4 PoE, 75 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/ISW2000-4T2GP-POE-IN/',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 75,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 4.8,
      management: 'unmanaged',
      formFactor: 'industrial-DIN',
      fanless: true,
      operatingTempC: '-30 to +65',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'uniview-isw2000-8t2gp-poe-in',
    manufacturer: 'Uniview',
    model: 'ISW2000-8T2GP-POE-IN',
    category: 'poe-switch',
    tagline: 'ISW2000-8T2GP-POE-IN — 6-port, 4 PoE, 75 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/ISW2000-4T2GP-POE-IN/',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 75,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 4.8,
      management: 'unmanaged',
      formFactor: 'industrial-DIN',
      fanless: true,
      operatingTempC: '-30 to +65',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'uniview-isw2000-8gt2gp-in',
    manufacturer: 'Uniview',
    model: 'ISW2000-8GT2GP-IN',
    category: 'poe-switch',
    tagline: 'ISW2000-8GT2GP-IN — 6-port, 4 PoE, 75 W, unmanaged',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/ISW2000-4T2GP-POE-IN/',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 75,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 4.8,
      management: 'unmanaged',
      formFactor: 'industrial-DIN',
      fanless: true,
      operatingTempC: '-30 to +65',
      surgeProtectionKV: 4,
    },
  },
  {
    id: 'uniview-nsw5630-48gp4xp-in',
    manufacturer: 'Uniview',
    model: 'NSW5630-48GP4XP-IN',
    category: 'poe-switch',
    tagline: 'NSW5630-48GP4XP-IN — 52-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Aggregation_Switches/NSW5630-48GP4XP-IN/',
    specs: {
      totalPorts: 52,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 176,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw5630-48gt4xp-in',
    manufacturer: 'Uniview',
    model: 'NSW5630-48GT4XP-IN',
    category: 'poe-switch',
    tagline: 'NSW5630-48GT4XP-IN — 52-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Aggregation_Switches/NSW5630-48GP4XP-IN/',
    specs: {
      totalPorts: 52,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 176,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw5630-24gt4xp-in',
    manufacturer: 'Uniview',
    model: 'NSW5630-24GT4XP-IN',
    category: 'poe-switch',
    tagline: 'NSW5630-24GT4XP-IN — 52-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Aggregation_Switches/NSW5630-48GP4XP-IN/',
    specs: {
      totalPorts: 52,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 176,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw6630-24xp2cq-in',
    manufacturer: 'Uniview',
    model: 'NSW6630-24XP2CQ-IN',
    category: 'poe-switch',
    tagline: 'NSW6630-24XP2CQ-IN — 26-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/NSW6630-24XP2CQ-IN/',
    specs: {
      totalPorts: 26,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x 100GE QSFP28',
      switchingCapacityGbps: 880,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw6630-48xp8cq-in',
    manufacturer: 'Uniview',
    model: 'NSW6630-48XP8CQ-IN',
    category: 'poe-switch',
    tagline: 'NSW6630-48XP8CQ-IN — 26-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/NSW6630-24XP2CQ-IN/',
    specs: {
      totalPorts: 26,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '2x 100GE QSFP28',
      switchingCapacityGbps: 880,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw5610-16gp8gc4xp-in',
    manufacturer: 'Uniview',
    model: 'NSW5610-16GP8GC4XP-IN',
    category: 'poe-switch',
    tagline: 'NSW5610-16GP8GC4XP-IN — 28-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/NSW5610-16GP8GC4XP-IN/',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 128,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +40',
    },
  },
  {
    id: 'uniview-nsw5610-48gt6xp-in',
    manufacturer: 'Uniview',
    model: 'NSW5610-48GT6XP-IN',
    category: 'poe-switch',
    tagline: 'NSW5610-48GT6XP-IN — 28-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Core_Switches/NSW5610-16GP8GC4XP-IN/',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x 10G SFP+',
      switchingCapacityGbps: 128,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +40',
    },
  },
  {
    id: 'uniview-nsw5660-28gp8xp-in',
    manufacturer: 'Uniview',
    model: 'NSW5660-28GP8XP-IN',
    category: 'poe-switch',
    tagline: 'NSW5660-28GP8XP-IN — 36-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Aggregation_Switches/NSW5660-28GP8XP-IN/',
    specs: {
      totalPorts: 36,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '8x 10G SFP+',
      switchingCapacityGbps: 216,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-nsw5660-28gt8xp-in',
    manufacturer: 'Uniview',
    model: 'NSW5660-28GT8XP-IN',
    category: 'poe-switch',
    tagline: 'NSW5660-28GT8XP-IN — 36-port, L3-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Aggregation_Switches/NSW5660-28GP8XP-IN/',
    specs: {
      totalPorts: 36,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '8x 10G SFP+',
      switchingCapacityGbps: 216,
      management: 'L3-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'uniview-isw5000-8gt4gp-poe-in',
    manufacturer: 'Uniview',
    model: 'ISW5000-8GT4GP-POE-IN',
    category: 'poe-switch',
    tagline: 'ISW5000-8GT4GP-POE-IN — 12-port, 8 PoE, 120 W, L2-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Access_Switches/ISW5000-8GT4GP-POE-IN/',
    specs: {
      totalPorts: 12,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '4x SFP GbE',
      switchingCapacityGbps: 24,
      management: 'L2-managed',
      formFactor: 'industrial-DIN',
      fanless: true,
      operatingTempC: '-30 to +65',
    },
  },
  {
    id: 'uniview-nsw5110-24gt4gp-in',
    manufacturer: 'Uniview',
    model: 'NSW5110-24GT4GP-IN',
    category: 'poe-switch',
    tagline: 'NSW5110-24GT4GP-IN — 28-port, L2-managed',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Transmission/Switches/Aggregation_Switches/NSW5110-24GT4GP-IN/',
    specs: {
      totalPorts: 28,
      poePorts: 0,
      poeBudgetW: 0,
      poeStandard: '802.3af',
      uplinks: '4x SFP GbE',
      switchingCapacityGbps: 56,
      management: 'L2-managed',
      formFactor: 'rack-1U',
      fanless: false,
      operatingTempC: '0 to +45',
    },
  },
  {
    id: 'linovision-poe-switch0604',
    manufacturer: 'Linovision',
    model: 'POE-SWITCH0604',
    category: 'poe-switch',
    tagline: 'POE-SWITCH0604 — 6-port, 4 PoE, 65 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://linovision.com/products/poe-switch0604',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 65,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45 Fast Ethernet',
      switchingCapacityGbps: 1.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
    },
  },
  {
    id: 'linovision-poe-switch2624u',
    manufacturer: 'Linovision',
    model: 'POE-SWITCH2624U',
    category: 'poe-switch',
    tagline: 'POE-SWITCH2624U — 6-port, 4 PoE, 65 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://linovision.com/products/poe-switch0604',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 65,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45 Fast Ethernet',
      switchingCapacityGbps: 1.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
    },
  },
  {
    id: 'linovision-poe-switch02ups',
    manufacturer: 'Linovision',
    model: 'POE-SWITCH02UPS',
    category: 'poe-switch',
    tagline: 'POE-SWITCH02UPS — 6-port, 4 PoE, 65 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://linovision.com/products/poe-switch0604',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 65,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45 Fast Ethernet',
      switchingCapacityGbps: 1.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
    },
  },
  {
    id: 'linovision-poe-switch1108gp',
    manufacturer: 'Linovision',
    model: 'POE-SWITCH1108GP',
    category: 'poe-switch',
    tagline: 'POE-SWITCH1108GP — 6-port, 4 PoE, 65 W, unmanaged',
    verified: true,
    datasheetUrl: 'https://linovision.com/products/poe-switch0604',
    specs: {
      totalPorts: 6,
      poePorts: 4,
      poeBudgetW: 65,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x RJ45 Fast Ethernet',
      switchingCapacityGbps: 1.6,
      management: 'unmanaged',
      formFactor: 'desktop',
      fanless: true,
    },
  },
  {
    id: 'sunell-sn-nsw10p8c-shtml',
    manufacturer: 'Sunell',
    model: 'SN-NSW10P8C.SHTML',
    category: 'poe-switch',
    tagline: 'SN-NSW10P8C.SHTML — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.sunellsecurity.com/products/poe-switch/sn-nsw10p8c.shtml',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
    },
  },
  {
    id: 'sunell-sn-nsw10p8t-shtml',
    manufacturer: 'Sunell',
    model: 'SN-NSW10P8T.SHTML',
    category: 'poe-switch',
    tagline: 'SN-NSW10P8T.SHTML — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.sunellsecurity.com/products/poe-switch/sn-nsw10p8c.shtml',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
    },
  },
  {
    id: 'sunell-sn-nsw18p16-shtml',
    manufacturer: 'Sunell',
    model: 'SN-NSW18P16.SHTML',
    category: 'poe-switch',
    tagline: 'SN-NSW18P16.SHTML — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.sunellsecurity.com/products/poe-switch/sn-nsw10p8c.shtml',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
    },
  },
  {
    id: 'sunell-sn-nsw20p16a-shtml',
    manufacturer: 'Sunell',
    model: 'SN-NSW20P16A.SHTML',
    category: 'poe-switch',
    tagline: 'SN-NSW20P16A.SHTML — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.sunellsecurity.com/products/poe-switch/sn-nsw10p8c.shtml',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
    },
  },
  {
    id: 'sunell-sn-nsw28p24b-shtml',
    manufacturer: 'Sunell',
    model: 'SN-NSW28P24B.SHTML',
    category: 'poe-switch',
    tagline: 'SN-NSW28P24B.SHTML — 10-port, 8 PoE, 120 W, smart-managed',
    verified: true,
    datasheetUrl: 'https://www.sunellsecurity.com/products/poe-switch/sn-nsw10p8c.shtml',
    specs: {
      totalPorts: 10,
      poePorts: 8,
      poeBudgetW: 120,
      poeStandard: '802.3at',
      poePerPortW: 30,
      uplinks: '2x SFP GbE',
      switchingCapacityGbps: 20,
      management: 'smart-managed',
      formFactor: 'desktop',
      fanless: true,
    },
  },
];
